
import { CHANGE_EMAIL, PASSWORD_RESET_REQUEST, ENTER_PASSWORD, VERIFY_PASSWORD_ATTEMPT_CHANGE, RESEND_CODE_PHONE } from './constants';

export function changeEmail(email: string) {
  return {
    type: CHANGE_EMAIL,
    email,
  };
}

export function resetPassword(data: object) {
  return {
    type: PASSWORD_RESET_REQUEST,
    data,
  };
}

export function enterPassword(data: object) {
  return {
    type: ENTER_PASSWORD,
    data,
  };
}

export function verifyAttemptToChangePasswordAction(data: object) {
  return {
    type: VERIFY_PASSWORD_ATTEMPT_CHANGE,
    data,
  };
}

export function resendCodeAction(phone: string) { 
  return {
    type: RESEND_CODE_PHONE,
    phone,
  }
}